"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memoize;

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/system/memoize.js
// module id = 926
// module chunks = 0